

export const PathUtil = {

    dropSlashesAndId(str: string): string { 
        return str?.replace(/\d+$/, '').replace(/^\/|\/$/g, '').trim();
    },
}